import { gaEvent } from 'src/utils'

import { CartProductItem } from '../../types'
import { formatCartItemsToEcommerce, getTotalPriceByCart } from '../../utils'

/**
 * Parâmetro para {@link viewCartEvent}
 */
export type ViewCartEvent = {
  orderList: CartProductItem[]
}

/**
 * @deprecated usar function {@link ecommerceEvent} com eventName 'view_cart'
 * [TARGET]: Visualização do carrinho
 *
 * [CONTEXTO]: Ao entrar no carrinho devemos enviar um snapshot dos produtos atuais
 *
 * @param config - Objeto com dados do evento de ecommerce view_cart
 */
export const viewCartEvent = ({ orderList }: ViewCartEvent) =>
  gaEvent({
    event: 'view_cart',
    ecommerce: {
      currency: 'BRL',
      value: getTotalPriceByCart(orderList),
      items: formatCartItemsToEcommerce(orderList),
    },
  })
